import { isGlobalProject } from 'config';
import { applySchema } from 'helpers';
import {
  TypedForm,
  FormErrors as FormErrorsBase,
  ObjectSchema,
  object,
} from 'libs/form';
import { TFunc } from 'libs/i18n';
import {
  ReasonChangeFormType,
  reasonChangeSchema,
} from 'modules/client/common/forms/reasonChangeForm';

import { CompanyNameFormType, companyNameSchema } from './companyNameForm';
import {
  CompanyOrganizationalAndLegalFormFormType,
  getCompanyOrganizationalAndLegalFormSchema,
} from './companyOrganizationalAndLegalFormForm';
import {
  CompanyRegistrationAddressFormType,
  getCompanyRegistrationAddressSchema,
} from './companyRegistrationAddressForm';
import {
  CompanyResidentialAddressFormType,
  companyResidentialAddressSchema,
} from './companyResidentialAddressForm';
import {
  CompanyStateRegistrationFormType,
  getCompanyStateRegistrationSchema,
  getCompanyBaseStateRegistrationSchema,
} from './companyStateRegistrationForm';
import {
  CompanyTaxResidencyFormType,
  companyTaxResidencySchema,
} from './companyTaxResidencyForm';
import {
  LegalClientHeadPositionFormType,
  getLegalClientHeadPositionFormSchema,
} from './positionInCompanyForm';

export interface LegalClientLegalHeadFormType
  extends LegalClientHeadPositionFormType,
    CompanyNameFormType,
    CompanyTaxResidencyFormType,
    CompanyStateRegistrationFormType,
    CompanyRegistrationAddressFormType,
    CompanyResidentialAddressFormType,
    ReasonChangeFormType,
    CompanyOrganizationalAndLegalFormFormType {}

export const getSchema = (
  t: TFunc
): ObjectSchema<LegalClientLegalHeadFormType> => {
  const isGlobal = isGlobalProject();
  return object()
    .concat(getLegalClientHeadPositionFormSchema(t))
    .concat(companyTaxResidencySchema)
    .concat(companyNameSchema)
    .concat(companyResidentialAddressSchema)
    .concat(getCompanyRegistrationAddressSchema())
    .concat(reasonChangeSchema)
    .concat(
      isGlobal
        ? getCompanyBaseStateRegistrationSchema(t)
        : getCompanyStateRegistrationSchema(t)
    )
    .concat(
      applySchema(isGlobal, getCompanyOrganizationalAndLegalFormSchema(false))
    );
};

export const { Field, Form, useFormContext, Submit } =
  TypedForm<LegalClientLegalHeadFormType>();

export type FormErrors = FormErrorsBase<LegalClientLegalHeadFormType>;
